import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, X } from 'lucide-react';
import { formatCents } from '@/lib/premium-api';

const DISMISS_KEY_PREFIX = 'allviews.premium.upsell.dismissed:';

export default function PostPublishUpsell({ eventId, eventCategory, premiumTier, lookbookState }) {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(null);

  const isMemorial = (eventCategory || '').toLowerCase() === 'memorial';
  const isEligible = premiumTier === 'FREE' && lookbookState === 'LIVE' && !isMemorial;
  const storageKey = `${DISMISS_KEY_PREFIX}${eventId}`;

  useEffect(() => {
    if (!isEligible) { setDismissed(null); return; }
    try { setDismissed(localStorage.getItem(storageKey) === '1'); }
    catch { setDismissed(false); }
  }, [isEligible, storageKey]);

  const onDismiss = useCallback(() => {
    setDismissed(true);
    try { localStorage.setItem(storageKey, '1'); } catch { /* best-effort */ }
  }, [storageKey]);

  if (!isEligible || dismissed === null || dismissed) return null;

  return (
    <div className="bg-[#F4F8FF] border border-[#146BFF] rounded-xl p-4" data-testid="post-publish-upsell">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-[#146BFF] flex items-center justify-center flex-shrink-0">
          <Award className="w-[18px] h-[18px] text-white" />
        </div>
        <div className="flex-1">
          <p className="text-[15px] font-extrabold text-[#0B1B46]">Loved this launch?</p>
          <p className="text-[13px] text-[#0B1B46] mt-0.5 leading-[18px]">
            Publish a clean, unwatermarked version for {formatCents(295)}. One-time, per event. Your existing share link keeps working.
          </p>
        </div>
        <button onClick={onDismiss} className="p-1 text-[#5B6472] hover:text-[#0B1B46] transition-colors" data-testid="post-publish-upsell-dismiss">
          <X className="w-[18px] h-[18px]" />
        </button>
      </div>
      <button
        onClick={() => navigate(`/host-premium?event_id=${encodeURIComponent(eventId)}&preselect=PREMIUM_LITE`)}
        className="w-full h-10 mt-3 bg-[#146BFF] hover:bg-[#0F55CC] text-white font-semibold rounded-lg transition-colors"
        data-testid="post-publish-upsell-cta"
      >
        See premium tiers
      </button>
    </div>
  );
}
